import {
    setEventLastResults,
    setNextEventsTimestamp,
    setNoMoreBetsEvent,
    setReceivedEvents
} from "../actions/eventsActions";
import {showPlatformNotification} from "../actions/modalActions";
import {retrieveNextEventsData} from "./platformMessageHelpers";
import {enableDisableGame, setGameControllerState} from "../actions/gamesActions";
import {setServerTimeOffset, setServerTimeZoneOffset} from "../actions/platformActions";
import {MATCHDAY, NMB} from "../constants/identifiers";
import {groupMatchdayEvents} from "../helpers/eventHelpers";

export function handleTextNotification(notificationType, title, text, isNotificationLocalizable, notificationWildCards, isDismissible, dispatch) {
    dispatch(showPlatformNotification(notificationType, title, text, isNotificationLocalizable, notificationWildCards, isDismissible));
}

export function handleNMBNotification(params, dispatch) {
    if (params && params.eventId !== undefined && params.channel !== undefined) {
        dispatch(setNoMoreBetsEvent(params.eventId, params.channel, true));
        dispatch(setGameControllerState(params.channel, NMB, params.isGroupedEvent));
    }
}

export function handleGameStateChangeNotification(params, store) {
    if (params && params.channel !== undefined && params.state !== undefined) {

        if (store.getState().vpp && store.getState().vpp.games.length > 0) {
            let gameIndex = store.getState().vpp.games.findIndex(g => g.channel === params.channel);
            let game = store.getState().vpp.games[gameIndex];

            if (game !== undefined && game.state !== undefined && game.state.toString() !== params.state.toString()) {
                store.dispatch(enableDisableGame(gameIndex, params.state.toString()));
            }
        }
    }
}

export function handleFetchNextEventsTime(result, dispatch) {
    if (result !== undefined) {
        dispatch(setNextEventsTimestamp(result));
    }
}

export function handleFetchNextEventsListAndLastResults(result, dispatch) {
    if (result !== undefined && result.eventDetails !== undefined) {
        let events = retrieveNextEventsData(result.eventDetails);

        if (events !== undefined && events.length > 0 && events[0].eventType === MATCHDAY) {
            events = groupMatchdayEvents(events);
        }

        dispatch(setReceivedEvents(events, false, undefined));
        if (result.lastResults !== undefined && result.eventDetails !== null) {
            dispatch(setEventLastResults(result));
        }
    }
}

export function calculateAndSetServerTimeOffset(serverDateMilis, dispatch) {
    if (serverDateMilis !== undefined) {
        let clientDate = new Date();
        let offset = clientDate - new Date(serverDateMilis);
        dispatch(setServerTimeOffset(offset));
    }
}

export function calculateServerTimeZoneOffset(serverTimeZoneOffset, dispatch) {
    if (serverTimeZoneOffset !== undefined) {
        dispatch(setServerTimeZoneOffset(serverTimeZoneOffset));
    }
}

      


// WEBPACK FOOTER //
// ./src/communications/platformMessageHandlers.js